import SparkMD5 from 'spark-md5';

const CHUNK_SIZE = 1048576;

function getMD5(
  file: File,
  onSuccess: (md5: string) => void,
  onError: (err: Error) => void
) {
  const blobSlice =
    File.prototype.slice ||
    // @ts-ignore
    File.prototype.mozSlice ||
    // @ts-ignore
    File.prototype.webkitSlice;
  const chunks = Math.ceil(file.size / CHUNK_SIZE);
  const spark = new SparkMD5.ArrayBuffer();
  const fileReader = new FileReader();
  let currentChunk = 0;

  fileReader.onload = (e) => {
    const result = e.target!.result as ArrayBuffer;
    spark.append(result);
    currentChunk += 1;

    if (currentChunk < chunks) {
      loadNext();
    } else {
      onSuccess(spark.end());
    }
  };

  fileReader.onerror = () => {
    onError(new Error('文件解析错误'));
  };

  function loadNext() {
    const start = currentChunk * CHUNK_SIZE;
    const end =
      start + CHUNK_SIZE >= file.size ? file.size : start + CHUNK_SIZE;
    const blob = blobSlice.call(file, start, end);
    fileReader.readAsArrayBuffer(blob);
  }

  loadNext();
}

export default function getFileMd5(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    getMD5(file, resolve, reject);
  });
}
